import React from 'react';
import ReportHeader from '../../components/reports/shared/report-header';
import NewHireDevelopmentReportRecommendations from '../../components/reports/new-hire-development-report/new-hire-development-report-recommendations';
import CompetenciesJudgmentTips from '../../components/reports/shared/tips/competencies-judgment-tips';
import { INDIVIDUAL_VALUE_TIPS } from '../../components/reports/shared/tips/acumen-values-experience-tips';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import PagedAcumenValuesExperienceTips from '../../components/reports/shared/tips/paged-acumen-values-experience-tips';
import { PRODUCT_CLASSIFICATION, REPORT_TYPE } from '../../utils/constants';

function NewHireDevelopmentReport({ candidate, creatingPdf }) {
  return (
    <>
      <div className="print-page print-heading">
        <ReportPdfHeader />
        <ReportHeader candidate={candidate} header="New Hire Development Recommendations" />
        <NewHireDevelopmentReportRecommendations candidate={candidate} developmentTips={true} />
      </div>
      <PagedAcumenValuesExperienceTips
        candidate={candidate}
        topFourMisAligned={true}
        valuesTips={INDIVIDUAL_VALUE_TIPS}
        classification={PRODUCT_CLASSIFICATION.develop}
        creatingPdf={creatingPdf}
      />
      <div className="print-page">
        <CompetenciesJudgmentTips candidate={candidate} nTips={1} reportType={REPORT_TYPE.development} />
      </div>
    </>
  );
}

export default NewHireDevelopmentReport;
